import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  getBookingCanceledByText,
  getInvoiceCancellationDetails,
  resolveAppointmentCancelledBy,
} from "helpers/cancellationDisplay";

/**
 * Shared invoice banner for cancelled bookings.
 */
const InvoiceCancellationDetails = ({ saleData, appointment }) => {
  const { t } = useTranslation();

  let details;
  if (appointment) {
    const isCancelled = appointment.status === "Cancelled";
    const cancelledBy = resolveAppointmentCancelledBy(appointment);
    details = {
      isCancelled,
      cancelledBy,
      canceledByText: cancelledBy
        ? getBookingCanceledByText(cancelledBy)
        : isCancelled
          ? "Booking Canceled"
          : "",
      statusLabel: isCancelled ? "Cancelled" : "",
      canceledAt: appointment.is_status_at || appointment.updated_at || "",
      cancellationReason: appointment.cancellation_reason || "",
    };
  } else {
    details = getInvoiceCancellationDetails(saleData);
  }

  if (!details.isCancelled) {
    return null;
  }

  let canceledAtFormatted = "";
  if (details.canceledAt) {
    const parsed = moment(
      details.canceledAt,
      [
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DDTHH:mm:ss.SSSSZ",
        "YYYY-MM-DDTHH:mm:ss.SSSSSSZ",
        moment.ISO_8601,
      ],
      true
    );
    canceledAtFormatted = parsed.isValid()
      ? parsed.format("DD/MM/YYYY hh:mm A")
      : moment(details.canceledAt).isValid()
        ? moment(details.canceledAt).format("DD/MM/YYYY hh:mm A")
        : "";
  }

  return (
    <li className="border-top my-3 pt-3">
      <p className="mb-1 text-danger fw-semibold">{t(details.canceledByText)}</p>
      <p className="mb-0 text-danger">
        {t("Status")}: {t(details.statusLabel)}
      </p>
      {canceledAtFormatted ? (
        <p className="mb-0 text-danger">
          {t("Canceled on")}: {canceledAtFormatted}
        </p>
      ) : null}
      {details.cancellationReason ? (
        <p className="mb-0 text-danger">
          {t("Reason")}: {details.cancellationReason}
        </p>
      ) : null}
    </li>
  );
};

export default InvoiceCancellationDetails;
